module.exports = __webpack_public_path__ + "static/media/water_blue.0f910966.png";